import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Editor } from 'react-draft-wysiwyg';
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import Swal from 'sweetalert2';
import htmlToDraft from 'html-to-draftjs';
import { Formik, Form, Field } from 'formik';
import { dynamicSort } from '../../../common/utils/api_utils';
import CustomOption from './CustomOption';
import CollectionSelect from '../CollectionSelect';
import { EditorState, ContentState } from 'draft-js';
import CustomLoader from '../../common/CustomLoader';
import {
  TypesenseSearchSchema,
  TypesenseSearchValidationSchema,
} from '../../../common/utils/smsMailTemplateValidationSchema';
import { getTemplateFormCollectionFieldOptions } from './TypesenseSeachTemplateFormUtils';
import { drapcodeIcon, iconForField } from '../../../common/custom/icon-library';
import CardTitleHeader from '../../../common/ui/CardTitleHeader';
import { CustomFieldModal } from './CustomFieldModal';
export default class TypesenseSearchTemplateForm extends Component {
  static propTypes = {
    editorState: PropTypes.object,
    value: PropTypes.object,
  };

  state = {
    editorState: this.props.editorState,
    name: this.props.name,
    collectionId: this.props.collectionId,
    selectedCollectionFields: this.props.selectedCollectionFields,
    addFieldsModal: false,
  };
  toggleAddFieldsModal = () => this.setState({ addFieldsModal: !this.state.addFieldsModal });

  onEditorStateChange = (editorState) => {
    this.setState({ editorState });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSelectChange = (name, value) => {
    if (this.state['collectionId']) {
      Swal.fire({
        title: 'Editor selected fields will be removed by this.',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, change it!',
      }).then((result) => {
        if (result.isConfirmed) {
          this.setCollectionDataInState(value);
        }
      });
    } else {
      this.setCollectionDataInState(value);
    }
  };

  handleSubmit = (values) => {
    values = {
      ...values,
      collectionId: this.state.collectionId,
      templateType: 'TYPESENSE_SEARCH',
      content: draftToHtml(convertToRaw(this.state.editorState.getCurrentContent())),
    };

    this.props.handleSubmit(values);
  };

  updateStateAfterSave = (editorState, value) => {
    this.setState({ value: value, editorState: editorState });
  };

  typesenseMappingCollectionsOptions = () => {
    const { collections } = this.props;
    const typesenseMappingCollections = collections.filter((col) => col.typesenseMapping.length);
    let options = [{ value: '', label: '-Select One-' }];
    options = options.concat(
      typesenseMappingCollections.sort(dynamicSort('collectionTitle')).map((collection) => {
        return { value: collection.collectionName, label: collection.collectionTitle };
      }),
    );
    return options;
  };

  setCollectionDataInState = (value) => {
    const { collections } = this.props;
    const selectedCollection = collections.find((e) => e.collectionName === value);
    let selectedCollectionFields = selectedCollection
      ? getTemplateFormCollectionFieldOptions(selectedCollection, collections)
      : [];
    let currentEditorContent = draftToHtml(
      convertToRaw(this.state.editorState.getCurrentContent()),
    );
    const regex = new RegExp(/{{(.*?)}}/g);
    currentEditorContent = currentEditorContent.replace(regex, '');
    console.log(currentEditorContent);
    const blocksFromHtml = htmlToDraft(currentEditorContent);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const editorState = EditorState.createWithContent(contentState);
    this.setState({
      collectionId: value,
      selectedCollectionFields: selectedCollectionFields,
      editorState,
    });
  };

  render() {
    const { editorState, collectionId, selectedCollectionFields } = this.state;
    const {
      updateTemplatePending,
      createTypesenseSearchTemplatePending,
      templateId,
      collections,
      projectDetail,
      name,
    } = this.props;
    TypesenseSearchSchema.name = name ? name : '';
    return (
      <>
        <CardTitleHeader title={`${templateId ? 'Edit' : 'Create'} Typesense Search Template`} />
        <Formik
          enableReinitialize={true}
          initialValues={TypesenseSearchSchema}
          validationSchema={TypesenseSearchValidationSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values);
            setSubmitting(false);
          }}
        >
          {({ errors, touched, values }) => (
            <Form className="form-horizontal">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div className="form-group">
                  <span className="label text-muted">Name</span>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('text')}`}></i>
                      </span>
                    </div>
                    <Field type="text" name="name" className="form-control" placeholder="Name" />
                    {touched.name && errors.name && <p className="errors">{errors.name}</p>}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-11 col-lg-11 col-sm-11 col-xs-11 ml-3">
                  <span className="label text-muted">Collection</span>
                  <CollectionSelect
                    options={this.typesenseMappingCollectionsOptions}
                    value={collectionId}
                    onChange={this.handleSelectChange}
                  />
                </div>
                <div className="input-group-append">
                  <span
                    className="input-group-text"
                    data-tip="Typesense Search Template"
                    title="Shows you the list of collections you have created in your web app builder. You can select the collection that contains the typesense mapping."
                  >
                    <i className={`wb ${drapcodeIcon('description')}`}></i>
                  </span>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div className="form-group">
                  <span className="label text-muted">Content</span>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text">
                        <i className={`wb ${iconForField('text')}`}></i>
                      </span>
                    </div>
                    <Editor
                      editorState={editorState}
                      editorClassName="form-control mail-editor border-left-editor border-right-editor"
                      wrapperClassName="form-group form-control h-auto no-bg-img"
                      onEditorStateChange={this.onEditorStateChange}
                      placeholder="Content"
                      toolbarCustomButtons={[
                        <CustomOption selectedCollectionFields={selectedCollectionFields} />,
                        <CustomFieldModal
                          collectionId={collectionId}
                          collections={collections}
                          addFieldsModal={this.state.addFieldsModal}
                          toggleAddFieldsModal={this.toggleAddFieldsModal}
                          projectDetail={projectDetail}
                        />,
                      ]}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-right">
                <button
                  style={{ marginBottom: '20px' }}
                  type="submit"
                  className="btn btn-theme-submit btn-md"
                >
                  <i className={`wb ${drapcodeIcon('save')}`}></i>
                  &nbsp;{templateId ? 'Update' : 'Save'}&nbsp;
                  <CustomLoader
                    loading={
                      (updateTemplatePending !== undefined && updateTemplatePending) ||
                      (createTypesenseSearchTemplatePending !== undefined &&
                        createTypesenseSearchTemplatePending)
                    }
                  />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </>
    );
  }
}
